import { VaultRole, type PermissionsItem } from '@/modules/api/codegen';
import { AccessRole } from '@/types';
import { permissionByRole, permissionToRole } from '@/utilities/permission';

/**
 * The vault contract defines two roles, so the shared member rows — which speak sharing permissions —
 * must be narrowed to the two that round-trip. A third role would break the mapping below.
 */
export const VAULT_ACCESS_ROLES = [AccessRole.VIEWER, AccessRole.EDITOR];

const accessRoleByVaultRole = {
    [VaultRole.editor]: AccessRole.EDITOR,
    [VaultRole.viewer]: AccessRole.VIEWER,
} satisfies Record<VaultRole, AccessRole>;

export const vaultRoleToPermissions = (role: VaultRole): PermissionsItem[] => permissionByRole[accessRoleByVaultRole[role]];

// Deliberately lossy: only EDITOR survives as `editor`. The autofill-only and passkey-only sharing roles
// have no vault equivalent, so they collapse to `viewer` rather than being smuggled through.
export const permissionsToVaultRole = (permissions: PermissionsItem[]): VaultRole =>
    permissionToRole(permissions) === AccessRole.EDITOR ? VaultRole.editor : VaultRole.viewer;
